import {
  ANSWER_ADMIN_LIST_FAIL,
  ANSWER_ADMIN_LIST_REQUEST,
  ANSWER_ADMIN_LIST_SUCCESS,
  ANSWER_ADMIN_LOAD_FAIL,
  ANSWER_ADMIN_LOAD_REQUEST,
  ANSWER_ADMIN_LOAD_SUCCESS,
  ANSWER_CONTINUE_FAIL,
  ANSWER_CONTINUE_REQUEST,
  ANSWER_CONTINUE_SUCCESS,
  ANSWER_LIST_FAIL,
  ANSWER_LIST_REQUEST,
  ANSWER_LIST_SUCCESS,
  ANSWER_RESET_FAIL,
  ANSWER_RESET_REQUEST,
  ANSWER_RESET_SUCCESS,
  ANSWER_RESPONSE_FAIL,
  ANSWER_RESPONSE_REQUEST,
  ANSWER_RESPONSE_SUCCESS,
  ANSWER_SAVE_FAIL,
  ANSWER_SAVE_REQUEST,
  ANSWER_SAVE_SUCCESS,
  NEW_ANSWER_FAIL,
  NEW_ANSWER_REQUEST,
  NEW_ANSWER_SUCCESS,
} from '../constants/answerConstants';

export const answerReducer = (state = {}, action) => {
  switch (action.type) {
    case NEW_ANSWER_REQUEST:
    case ANSWER_RESPONSE_REQUEST:
    case ANSWER_CONTINUE_REQUEST:
    case ANSWER_SAVE_REQUEST:
    case ANSWER_RESET_REQUEST:
      return { ...state, loading: true };
    case NEW_ANSWER_SUCCESS:
    case ANSWER_RESPONSE_SUCCESS:
    case ANSWER_CONTINUE_SUCCESS:
    case ANSWER_SAVE_SUCCESS:
    case ANSWER_RESET_SUCCESS:
      return { loading: false, answer: action.payload };
    case NEW_ANSWER_FAIL:
    case ANSWER_RESPONSE_FAIL:
    case ANSWER_CONTINUE_FAIL:
    case ANSWER_SAVE_FAIL:
    case ANSWER_RESET_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const answerListReducer = (state = {}, action) => {
  switch (action.type) {
    case ANSWER_LIST_REQUEST:
      return { ...state, loading: true };
    case ANSWER_LIST_SUCCESS:
      return { loading: false, answers: action.payload };
    case ANSWER_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const answerAdminListReducer = (state = {}, action) => {
  switch (action.type) {
    case ANSWER_ADMIN_LIST_REQUEST:
      return { ...state, loading: true };
    case ANSWER_ADMIN_LIST_SUCCESS:
      return { loading: false, answers: action.payload };
    case ANSWER_ADMIN_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export const answerAdminLoadReducer = (state = {}, action) => {
  switch (action.type) {
    case ANSWER_ADMIN_LOAD_REQUEST:
      return { ...state, loading: true };
    case ANSWER_ADMIN_LOAD_SUCCESS:
      return { loading: false, answer: action.payload };
    case ANSWER_ADMIN_LOAD_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
